import axios from 'axios';
import { API_ENDPOINTS, getAuthHeaders } from '../config/api';
import { runCachedRequest } from '../_helpers/requestCache';

export const cartApi = {
  getCart,
  addToCart,
  removeFromCart,
  clearCart,
  sendCart,
  downloadCart,
  downloadOutgoingCart,
  listCart,
};

function getCart() {
  const url = API_ENDPOINTS.CART.GET;
  const options = {
    method: 'GET',
    headers: getAuthHeaders(),
    url,
  };
  return runCachedRequest(
    'cart:get',
    () => axios(options),
    { ttl: 15 * 1000 },
  );
}

function addToCart(assetId, downloadFormatId = null) {
  const url = API_ENDPOINTS.CART.ADD;
  const data = { assetId };
  if (downloadFormatId) {
    data.downloadformatId = downloadFormatId;
  }
  const options = {
    method: 'POST',
    headers: getAuthHeaders(),
    data,
    url,
  };
  return axios(options);
}

function removeFromCart(assetId, downloadformatId = null) {
  const url = API_ENDPOINTS.CART.REMOVE;
  const data = { assetId };
  if (downloadformatId) {
    data.downloadformatId = downloadformatId;
  }
  const options = {
    method: 'DELETE',
    headers: getAuthHeaders(),
    data,
    url,
  };
  return axios(options);
}

function clearCart() {
  const url = API_ENDPOINTS.CART.CLEAR;
  const options = {
    method: 'DELETE',
    headers: getAuthHeaders(),
    url,
  };
  return axios(options);
}

function sendCart(receiver, lang, subject = '', message = '') {
  const url = API_ENDPOINTS.CART.SEND;
  const options = {
    method: 'POST',
    headers: getAuthHeaders(),
    data: { 
      receiver,
      lang,
      subject,
      message
    },
    url,
  };
  return axios(options);
}

function downloadCart() {
  const url = API_ENDPOINTS.CART.DOWNLOAD;
  const options = {
    method: 'GET',
    headers: getAuthHeaders(),
    url,
    responseType: 'blob'
  };
  return axios(options);
}

function downloadOutgoingCart(cartId) {
  const url = API_ENDPOINTS.CART.DOWNLOAD_OUTGOING.replace('{id}', cartId);
  const options = {
    method: 'GET',
    headers: getAuthHeaders(),
    url,
    responseType: 'blob'
  };
  return axios(options);
}

function listCart() {
  const url = API_ENDPOINTS.CART.LIST;
  const options = {
    method: 'GET',
    headers: getAuthHeaders(),
    url,
    responseType: 'blob',
  };
  return axios(options);
}
